import { Space, Grid, Chip, Card, Image, Text, Badge, Button, Group, useMantineTheme, Anchor, Avatar } from '@mantine/core';
import { IAsset } from 'atomicassets/build/API/Explorer/Objects';
import { useCallback, useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Api, Flame, Id, User } from 'tabler-icons-react';
import { CardImage } from './CardImage';
import { CardImageFull } from './CardImageFull';
import { IGenericCardProps } from './GenericCard';
import { AAMiddleware } from './../../../store/AAMiddleware'
import { resolveUrl } from '../../../lib/ImageHelper';

const api = new AAMiddleware()

interface IAssetCardProps extends IGenericCardProps {
  item: IAsset;
}

export function AssetCard({item, buttons, options, path} : IAssetCardProps) {
  // const [userAvatar,setUserAvatar] = useState()
  const theme = useMantineTheme();
  const secondaryColor = theme.colorScheme === 'dark'
  ? theme.colors.dark[1]
  : theme.colors.gray[7];

  if ( ! buttons ) { buttons = [] }
  if ( ! options ) { options = {} }


  // TODO: getUserAvatar is broken like this... ends up with TONS of parallel requests. Very very bad
  // useEffect(()=>{
  //   const loadUserAvatar = async () => {
  //     if ( ! item.owner ) { return }
  //     const avatar = await api.getUserAvatar(item.owner)
  //     if ( avatar ) {
  //       setUserAvatar(avatar)
  //     }
  //   }
  //   loadUserAvatar()

  // },[])

  const toPath = path + item.asset_id
  const image =  (
    <CardImage
      src={item.data.img}
      alt={item.data.name}
      onClick={()=>{}}
      />
  )

  return (
    <Card radius="lg" shadow={options.shadow} p="lg">

      <Card.Section>
          <Group position="center">
              { options.nolink ?
                  image
                  :   <Anchor component={Link} to={toPath}>
                        {image}
                      </Anchor>
              }
          </Group>
      </Card.Section>

      <Group position='apart'>
        <div>
          <Group position='left' style={{ marginBottom:0, marginTop: 0 }}>
            <Text align='left' pt='xl' pb={0} px='md' size='xs' weight={700} color={theme.colors.dark[3]}>{item.collection.name}</Text> 
          </Group>
          <Group position='left' style={{ marginBottom: theme.spacing.md, marginTop: 0 }}>
            <Text
                style={{
                  overflow: 'hidden',
                  maxWidth: '30ch',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }} 
                align='left' pt={0} px='md' size='xs' weight={700} color={theme.colors.dark[5]}>{item.name}</Text> 
          </Group>
        </div>
        <div>
          
          <Text size='xs' align='right'>
            Mint
          </Text>
          <Text size='sm' weight={700} align='right'>{item.template_mint}</Text>
        </div>

      </Group>

      <Group position='center'>
        <Group position="center">
          <Avatar size='sm' radius="xl"><Id size={24} /></Avatar>
          <Anchor component={NavLink} to={toPath}><Text weight={700} size='xs'>{item.asset_id}</Text></Anchor>       
        </Group>
        {/* {
          item.owner ?
          (
            <Group position="center">
              <Avatar size='sm' radius="xl" src={userAvatar ? resolveUrl(userAvatar,'w=25') : null}></Avatar>            
              <Anchor component={NavLink} to={toPath}><Text weight={700} size='xs'>{item.owner}</Text></Anchor>       
            </Group>  
          ) : ''
        } */}
        {
          ! item.owner && item.burned_by_account ?
          (
            <Group position="center">
              <Avatar size='sm' radius="xl"><Flame size={24} /></Avatar>            
              <Anchor component={NavLink} to={toPath}><Text weight={700} size='xs'>Burned</Text></Anchor>       
            </Group>  
          ) : ''
        }
      </Group>

      {
        buttons.map((b,i) => {
          return (
            <Button key={i} leftIcon={b.icon} variant="light" color="blue" fullWidth style={{ marginTop: 14 }} onClick={b.onClick}>
              {b.label}
            </Button>
          )
        })
      }
    </Card>    

  )
}
